import { Component, OnInit } from '@angular/core';
import { UsuarioService } from '../../services/usuario.service';
import { take } from 'rxjs/operators';
import { ClienteFisicoElement } from 'src/app/interfaces/cliente';
import { PedidoConsultaElement } from 'src/app/interfaces/pedido.consulta';

// const produtosParaZerar = [
//   "-N-Y34mfxeeE9aE_PDtF",
//   "-OHhyy0XaQUS6VM17uhi",
//   "-NlOxpPAQnTYAI5r9ONd",
//   "-NPwPiw8b8CGTiDXFUEC",
//   "-Nz3JC_Ro52NJzIQeMuM",
//   "-Ma3e7M7kSZGIz_dTJDJ",
//   "-N47Rc4A1uR9ZxQg_S5z",
//   "-NI3SfkoEHydmxKDtRtJ",
//   "-N47UUo86CoubCwKmfNJ",
//   "-N47RynNXvP61Oc3H6nH",
//   "-Nz3IpUG2bg4nZT3_HaY",
//   "-OHhzVv3nXvvKGMC4r9v",
//   "-NNmEXvIsEorV55nHovx",
//   "-NYOpzCIokkOTAKFitNy",
//   "-NWHkE9tn56A3_I5BGhI",
//   "-NnJKLihof8Ir9R-cbMF",
//   "-NWHfD8s1bZ8nX2Ev0CX",
//   "-MguAq1lleDd0jObHP6u",
//   "-NbyMfg6bJQYwp_3T1eR",
//   "-N-86RiAohh5wLSlaCOL",
//   "-Mfrhx2_JnUyfKuMy4GF",
//   "-N0fBmbWr0jyIWLCasU2",
//   "-Mgu8rGwn1zajOtvoE2z",
//   "-NlP4AchQ_d30j-tLQNP",
//   "-MfroXKB86hd4wcZk2Vr",
//   "-MnlGCpbwjki4ZFCS8yg",
//   "-NYOs6drDbSmlxPz23C5",
//   "-MacTc9-odt_BmYhyBG1",
//   "-NMJIlIe9hshoCwI8qHu",
//   "-Nij7Z9ZA3VErInEl0hZ",
//   "-MacUA3MFc2NDUQryJHJ",
//   "-OB0LJrRzNYD1jLrLRPg",
//   "-Nij9iB_8brDKxKYv5kb",
//   "-MfrmMPSXHLNCPQZo4H_",
//   "-Nij8dbN7CIQMzkhEjWs",
//   "-NijAB2U76mQd022GmeC",
//   "-NJjgZmHwBF1NonQxTe8",
//   "-NZ5qyornCZKtBesPhYK",
//   "-NlOymELonOzFd_5WtWJ",
//   "-NKIf-SPT7xUAK_oX_dl",
//   "-Ma3jPdInZUlu-v18MMn",
//   "-Mfrp8QwP5q-N6nxmCn7",
//   "-MfrpgSBjqePa4wiYN10",
//   "-Ma3kDh_K4sPFMw73rV3",
//   "-MfrptaRzuuYMzwIyJPO",
//   "-NzhZcSB1lU-_uHhNpj7",
//   "-Nzh_0HOyBt8XnNe-_rS",
//   "-MguBNMWz-tGnTv5d07J",
//   "-MbbVVzLG4s_w2NtyY-V",
//   "-MacPlOdes8rLxb2p5BJ",
//   "-Nzhafg7QTgUuACeG7jN",
//   "-MacPz0g-58wSkUnPnJi",
//   "-Mfrqe99diD5BdFwx-pY",
//   "-MhDyp6cLI33seaKsmX6",
//   "-MacQYxzOZbH14bzOKWe",
//   "-MacQiN6OI0bpxVqnEhu",
//   "-MacQtJB4_a7xGw2qFwA",
//   "-MfsRTRckXIoZeE8Qu82",
//   "-NCz55OLNZhprE_NKUaC",
//   "-MfrrF_Z4i5mTWYiOzEU",
//   "-O0soLppO-nIX6nuD7Ot",
//   "-NJQIctZu9oBgDcvC2U8",
//   "-NJQHzTT9TbRgaFyFcku",
//   "-NJQILFRR95ofgeCmqW3",
//   "-NHEhB2rmGSoc7KL92hG",
//   "-NbZlmwwh1JJizVvEb3U",
//   "-MbapjgjXKtPt6qQXSjo",
//   "-MkgyfIerUSB99SuhESt",
//   "-MbaqSeW6oArahtmppav",
//   "-MbarFrUa5fDJ4XJeBPH",
//   "-MkbnlV3ryyYnyilSkR8",
//   "-Nz3JwRAlZqw8yoaGdf_",
//   "-MacS_ZoM-QLXf5OXsoH",
//   "-Nzo5zxIv9fIcJYq-Bx4",
//   "-MnlI7lTX1BLQnQtkgE3",
//   "-NnJW6pkBrvP3MYmJDPx",
//   "-Nij65_al6UrjDekYk7c",
//   "-MfsaeFHsrMSJalncTjW",
//   "-NzhVVegb1qWmE0H3hJx",
//   "-O38lHGfrCzqKmYFTk_p",
//   "-MkhiFulVMs_8Na8qKqO",
//   "-MhOiNXyxrXNMqYim_5V",
//   "-MbaoZ47G0sIfIcfmxt0",
//   "-Mbarw4cfqoVLK0-1Eea",
//   "-Mbas8G0g-hoMtzuQHsX",
//   "-NbyN124nVAHJMLS8Ton",
//   "-N-Tuv3TAOkBQ-3jdQZ9",
//   "-NhlWVm7F9HmVG0h84FK",
//   "-N3URN2AxvfTZnNVsbEI",
//   "-Ma3j-uV31lFHl2MdiyL",
//   "-NhlWENEIK8Bb_ZzT-LI",
//   "-MxFnkfGUwYqcZ6QDKBc",
//   "-N0evT8kmafe2tu8L5ea",
//   "-MmsUU5-tNqhIfvBoDI9",
//   "-MacWx6NPSIkC4V-hf1p",
//   "-NbyNKVDZggTcvvZA4su",
//   "-NCzCNsKok-cZ69Gb77Z",
//   "-MlBaiLGfw-1-npGal0Q",
//   "-NbuP0bujTTJ-GTc2Q5m",
//   "-NbuOeCGNhggpd-D7evm",
//   "-MvTlj_XtfCUwSglV6fW",
//   "-MvTm26E03ICOQwMSaHD",
//   "-NlOx-r1d0fALIx9eMO3",
//   "-NbuYdovNoGauHe97WY7",
//   "-MmsRxBLAbPO0--Feb0k",
//   "-NlP2YYjfTaq3dhdnBOg",
//   "-Mfro3XWhMC6G7dIgN0-",
//   "-MkhhplTy7TcqSVD3HRG",
//   "-MlBPrne0m09_TQf3vtP",
//   "-MqUXEXPpkvElF1rAz6B",
//   "-MkO5u71eviKCRvV0SxZ",
//   "-NPbiwSnbzEkuxMvVHSh",
//   "-N-TuuzYG4UdsVvLQdi9",
//   "-Nz3IXWNCXWMVnFrwMWD",
//   "-NlPAXuNpM6v5UhnZwnH",
//   "-NPbm90_x6NBpnu5SKwG",
//   "-MfsidB0qaExwm-qIqWS",
//   "-MfsfCqISgA6hPM9HYEP",
//   "-N5jWWK_-NuQS9jQMFpu",
//   "-Mm2p350bUdVTsJJLMww",
//   "-OHhzDTzHl158cHqHATp",
//   "-OHhx_SffFuadbEx2Rrm",
//   "-NnJKeT_MSNUIw0SJg1x",
//   "-MfsS0TaN_FixBaOkJMA",
//   "-MkcgMfy01i3sziBONrv",
//   "-NMUfDPio1iWwkngmAVG",
//   "-Nzhl4thfNaLeyUcUM_5",
//   "-NzhlU8NqqCBsCIBd-sY",
//   "-NWN-bb8ZdSJg6oVQiDQ",
//   "-Mw2pPmE3XjFe6Ww7v2i",
//   "-N47TUzlmW5gubjAMCvk",
//   "-NnJVllSFQNQju-n-h6v",
//   "-N5jflBYvxVkIUY8yuzr",
//   "-MacSDuh3pAzyMrXCsuM",
//   "-MfsZbvikrMYYqRCrjiy",
//   "-NzhnOIN_0pkNe9wNxSr",
//   "-NRhIW7Ue848U0WMRmkm",
//   "-N3UQBtT0K_dtuV1Eh8l",
//   "-MkqC8lkrjPnjoZ4KpCT",
//   "-Mgu8_Q5NV6TTRIi16Yk",
//   "-MfrlzYQAXWyDu2P0ZxT",
//   "-N3UNttfPHIqipbu3-9k",
//   "-NNmF0PtnGTJruxFJ_0y",
//   "-N8e3tlJDuTBaCg0wgvx",
//   "-NRhatk_6_Io0XBhHhTQ",
//   "-NMUen0329RCmXmsJfWr",
//   "-NMUhggJsfw3WmFKDIDC",
//   "-MlBSOBxKZeNa32jC6ka",
//   "-MfwXLrchJSUP4ViQ9m7",
//   "-MmsV8OaDF7xjDSVjgQL",
//   "-NRhJtm8PRd7m6ZTzG9j",
//   "-N3UOi8NaQTMZGBKeIoE",
//   "-NRhLWq564Np59nFrdGL",
//   "-NRhL1NhbYBBhuOv70EM",
//   "-MlBaJO78o_vz2kRSs55",
//   "-Mox8DbdKakhJ9PeBBdD",
//   "-NZGEuwwU7MAG3BEJJkI",
//   "-MpCPstlYARkiveI1Gqg",
//   "-N47UrggYVo5V3DgA5le",
//   "-NUWr-FhGCCTBUET5DNJ",
//   "-N47U37wav5P3kJ1q_RH",
//   "-Ma3jFjbwN9V_GjN-TYv",
//   "-NlP5no_6fiOduVVxaF0",
//   "-NlP6cdubc8kNfa56BRq",
//   "-NaMM_ibL_hsMO3gOVoy",
//   "-Nz3HWUWcbTiQ8Jjp3JU",
//   "-MbawlzMaFcLCq3WgoAG",
//   "-MacWWWU8YUEYt8AJuoP",
//   "-MbbSDJVmjmwh8J-s0kZ",
//   "-NUWpL2ArU_ut9IkTGtQ",
//   "-NbyC5tlxxFq5DYY5b7k",
//   "-MhE9zhBtFuJHOcS48zb",
//   "-NPwJMqab341_jTk-pvG",
//   "-NPwMyTUvZna99S-TAZU",
//   "-MkherHO6fqOAue3mjEW",
//   "-NJGcCD26a--Er4pINL0",
//   "-MacRcv3OwbpDggPZ_8Z",
//   "-MkhgpbqtKHu8yn_CiNb",
//   "-MmsU03jrveFY_q0H5pm",
//   "-MkhhDw0KULSaViZ8Hpp",
//   "-NY2rw68VZOqjTKlWsJ_",
//   "-NY2sH_5X5kgC9Oi5DdQ",
//   "-NaIL843y-vZRv2TFPTf",
//   "-MhI_F2BIYLCLnxYSihx",
//   "-MfwOLi_ZI_Tmq5-j4-g",
//   "-MbbU2rbznBtkUh7xcfy",
//   "-MlBZvhhp_NJrgI5ywwJ",
//   "-NCz93dlcZ9Gs__666HB",
//   "-N892qgEHAgRLiGxClyQ",
//   "-N3UKMswiwYqZcHmcUna",
//   "-N3UKhOAmk-a7hH6IJWc",
//   "-N3ULEfZKeJGENkuplmY",
//   "-N3US_AFicrjoqLTPsdJ",
//   "-NZGG8cktu91jQ-dmn3Z",
//   "-NY2rC_JGtwgCw4QCAvG",
//   "-MlAt2wPJLcoTK4gHxB9",
//   "-NQFMoFbe6BAiYndJkio",
//   "-NzhXVbplK0o0aGN27ne",
//   "-NzhX4wlsVtl-Jd0v5eF",
//   "-MbbWyJO5Or7HrwPfHXA",
//   "-MguAMsPSCozjWxKwI0Y",
//   "-NzhqUKRRJYEfzTAY4VG",
//   "-NT-kfr53dm6SCC_XLvx",
//   "-MhOhBMNEsP6OpQJohtc",
//   "-NRnc5l_y4lTBuyBpR8g",
//   "-NP2exZnLtzQTx9PaKjY",
//   "-Nzhnu17hzJ_m11kl7Kc",
//   "-NzhoOo8cHB96G_T2FT-",
//   "-NzhopUIGGUm1ryHWJ88",
//   "-NWHs0DV9dj81Ge8H0Fc",
//   "-NhlWuGpqWN2oYwo6A4f",
//   "-MbbY8NAeyOZ05f2iJj7",
//   "-MbbYPULFlt-wZyM5nIn",
//   "-MbbYHobgN6QvAJDWuyc",
//   "-NhlXtluheGw5-rw4MK_",
//   "-MacUYPN3IG95rBGmKwQ",
//   "-MacUmmMlgPWYZIM3bQX",
//   "-MfwRcVA92hZItuWYX25",
//   "-MbbaGR8gn583RgZ2doh",
//   "-MzzF0uhyOAhfPt6Z9J-",
//   "-Nz3L2Wub5CWqhHehQE5",
//   "-NZGESwobx4fX0tXt7jG",
//   "-MfwQcf2zDB3KbgohW8N",
//   "-MfwS5Dgb5FU3JyDJwqd",
//   "-MhEBH6u_4UuvOwGgg0e",
//   "-MhEBjAjioa7pIFRBj3g",
//   "-Mbbec9pdWyq3uWXf12p",
//   "-Mbbcv9v_nG84VmxrLnP",
//   "-MbbcWJsf4x_OEW0CBTq",
//   "-NnJPrRzTU6PTm9Bysb5",
//   "-Nzhr6OaRSm31f_hXnj1",
//   "-NzhcHII9cLVmETNe51S",
//   "-NzhbtCkukuqmjH3z55c",
//   "-NzhccuZqNmHlEiu3Mi9",
//   "-NY2soVho6MSoo7SIgtS",
//   "-MfwWJZ61CksePZuIYW1",
//   "-MlBTzJxPjYSlVCdAPhk",
//   "-MlBLmqE4hBxxRYlLe8r",
//   "-NUWonDmgzC_9dhIlLNV",
//   "-NzhWTfH5eEgRHe7ErTZ",
//   "-O3X_B7thQ5yUQS227ZV",
//   "-NnJMJGTsDaH-Hqj2qDN",
//   "-NnJLwoScqt1X8oTt-mm",
//   "-NnJLarsHTt2AnaLDkes",
//   "-N6raddtNtyPhmJu9Z-B",
//   "-NlPBSClWFxdo8sESaTP",
//   "-MqUYNn6X42Dv_9n9F3T",
//   "-MlBMb3dIuPeMOoS1gFx",
//   "-OHi05sIRcdtD-fDhGqd",
//   "-MfrlRVP6eYI-fjy6P24",
//   "-MfrniP7sINgQiYIFThy",
//   "-Ma3eMxoUS5LiCVtivyE",
//   "-MacUdyZ_tthwRHz1yJI",
//   "-MfwMG5FdRE9bZFPKg9o",
//   "-MbbiR5N0xyD5FXOc5-N",
//   "-MmsTK94SpKVuM4ut-pV",
//   "-MacRUn-ACxL1nRiOnYZ",
//   "-MhE3DA9nH0_HWuZyIYB",
//   "-NCzBIQwRSXONUCme0AN",
//   "-NRhgnqsOaphPJOdyK2Y",
//   "-MhE3V0p5mX8ol8qjj_b",
//   "-NCzET7paky2vZZD2mVy",
//   "-NCzEmhlB5BE5_-oF61K",
//   "-N0pNjNoxJqnLI1p9gLr",
//   "-N0fF40uaa9uhbstojva",
//   "-MhE2rjGFA-D_FkfqfzZ",
//   "-MbbbYF7jLApWLcCtlCf",
//   "-N5aHGb8hhAkFVIR36XE",
//   "-MxFpqjdAzzRNmj2bhO5",
//   "-MkrKTL9e5tzrQ_VEw9f",
//   "-MhI_ZyAE-Of1ML3jvVm",
//   "-MhI_RYJiVxtmr8w6Ezc",
//   "-N-TymOWoTwawBOA7rPd",
//   "-NVsk183wGZLLn9EZCJz",
//   "-MfwR7iUsK2VeSxRQcxG",
//   "-MhEAIx2f_-fSjIdkK1K",
//   "-MhEAcCNwJyPuidPZYI3",
//   "-MhEC2MF2YvYiBR0gKA1",
//   "-NlcaepDY8npwOJP6tdr",
//   "-N-Y7o46lOPwVNFPOA4Q",
//   "-N-Y8cZR5praeRCEPMXD",
//   "-N5aIKzuqKgxsdCZ5l2I",
//   "-NYc2W4yVU8kKVwQmAB2",
//   "-MwaHQqvXweOfcltli0u",
//   "-N3-3ngVndKKT2EbRzqV",
//   "-MwaHhohbZHls9kBNp_p",
//   "-MrMX4K-mKfC-MWh2DP7",
//   "-MxFq75HFBlqacN3m9JE",
//   "-MrMXOVlSzUYiL0GE8z-",
//   "-N1e3-x0ARCJiz6ICNCi",
//   "-MacZJndWOckwxzmsQqp",
//   "-MbakbhgHKDodR9VWM9y",
//   "-MbalDL7wOfX4wOfhUEu",
//   "-MbalPzKf2yrAd0p2EPo",
//   "-MbalciE_g7ba4Hz8-6z",
//   "-MbamUlMtJNLhAgdB6e4",
//   "-Mvy0aqaSXyB-kVorB1P",
//   "-Mvy04tn7BcmKSrg73OX",
//   "-Myli9PwYzrnPqhAaX2d",
//   "-Mvy18vQjk7KWVIxef6Y",
//   "-NVEu4ZvJCHfzxCzBcaq",
//   "-MguBtYCAC5gw0GhooMS",
//   "-NPwNJ4m-cNGrU52IdJy",
//   "-MiS_vzFovwjfWJvR97G",
//   "-MxFr0g7NZ7O44m8u01P",
//   "-MbatsEB7KJ_j7siDsvF",
//   "-MiS_gKXoaqT3KRi-DRZ",
//   "-NWbeTW50G_8DaorijA8",
//   "-NWbeHOye1Htg2vzWj_I",
//   "-MrMYR8fR7bonfVsf_Mx",
//   "-MfwTYUKLVeYyMlnIjyV",
//   "-MlBQer1pGJ_krfU1ADs",
//   "-N6I6q49PQqqZQmy1WHg",
//   "-NVoBT4vVsxHvPgjiZGq",
//   "-NlNw5j-D2fZ3p8NCcMe",
//   "-NlNxJhBJfcU9EGxZrJ9",
//   "-MlBW9ehoqAjYaS2kVPr",
//   "-NlOwI8QRNtJdVNEqShf",
//   "-NnJMxXjFPOs8_6-_JLD",
//   "-Nzhj0Ugzj0-dCJwxBGF",
//   "-NnJIYlRidXy0UDXqloI",
//   "-NnJJ2hNKXpM8G1a0PbJ",
//   "-NzhjRX61jT4RxqR1dYE",
//   "-NzhjvRNXvQxQ89pyVWj",
//   "-NzhkJRIPbhN2DTcu56j",
//   "-NbyAwZl9QcVjKsFImX2",
//   "-NbyA_xrB5aud-OlkxUm",
//   "-NbyBG_uuUqof6BvQTGb",
//   "-NbyAAu9LYqKxANxMN_g",
//   "-OHhxFro7Ts4DAVqPL0p",
//   "-MlBXFIXmVg0I50vrUKB",
//   "-MfwZefDIChNMgqgT_NJ",
//   "-MhOba5oKAs6dbvncXSc",
//   "-MhOcGIbh0eRgsiMd0AO",
//   "-MhOdJkwo9haidjIKe48",
//   "-NOyf8VFrrjiA4I_Fm6L",
//   "-NOyehqIb7rkgmp-Pyoh",
//   "-MiSaAYuhfEZFmunJA64",
//   "-MhOar1c0X7VqM7kBd55",
//   "-MbbUgNBIaZu4sOFGcvH",
//   "-MbbUrzmbiEAS3tzQlcc",
//   "-NnsW09VUO0-Ympp8qny",
//   "-NnsWIXSx1p0oJoJxIxG",
//   "-NnsWbHLtOa8W_2AVG1E",
//   "-MfwZ77Em5_B-3kjdudh",
//   "-Mfw_4DlhJMF8Rgp7YLT",
//   "-Mkl0LKCJvIUISJaZOq-",
//   "-MhOaRnSIUQK9oUc_vO3",
//   "-MstJa9KQDwA-cMUlYlC",
//   "-Mn1FJszovJ3AyHpD1oZ",
//   "-NtuchB7z2rqTTkzJ84b",
//   "-NtuZJO_8AZmDlvZwfe5",
//   "-Nzmcowr9pKiZ2Kg2kZ4",
//   "-NzmejCwfndFjPiJUdzC",
//   "-NzmdfQbjWZed2WPcInN",
//   "-Nzmf5_Vk58RGdlhYFLP",
//   "-NzmfKwkTrNWTVZBRhdp",
//   "-NzmhF6zI3PzndZX6gsf",
//   "-NzhRkc4ZF33CNaGHy4o",
//   "-NzhUFnS8B5cGk4Wa69A",
//   "-NzhUjspYmtuGBFumk60",
//   "-NzhSV5kgNkw9mD7RLbC",
//   "-NfLfaTs5TJHF72sIAwi",
//   "-MhDyBcvSo4PwCsxgLf_",
//   "-MxFrRxiG73aoiA_F8x9",
//   "-NP2hjoZb1kr75qfMPcf",
//   "-Nz3J18R9mFpi2_hJQ_O",
//   "-NIgla7407FLTNi6gKuO",
//   "-MacTybT5U1Mr7eeR9DW",
//   "-O9iYcOuCSGquwENCMzP",
//   "-N-Tb3G-LJrRrOGmQLqJ",
//   "-NGah9iJU5ON_vrqCWY0",
//   "-MrMXwexP-uCtU7uf8Rh",
//   "-N89JW9qIjN9lPx6Iuim",
//   "-O38kwOo52roU2CXMq5r",
//   "-O38kX_aZJ-dqqi1pNF5",
// ];

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  constructor(
    private usuarioService: UsuarioService,
  ) {
    localStorage.setItem("tela_atual", "Dashboard");
  }


  ngOnInit(): void {

    // Atualiza quantidade estoque para aparecer no app
    // this.usuarioService.getProdutos().pipe(take(1)).subscribe(snap => {
    //   snap.forEach(async item => {
    //     const key = item.key;

    //     if (!key) return;

    //     if (produtosParaZerar.includes(key)) {
    //       console.log("Zerando estoque:", key);

    //       await this.usuarioService.updateProduto(
    //         { QuantidadeEstoque: 0 },
    //         key
    //       );
    //     }
    //   });
    // });

    //#region insere na tabela de produtos os estoques atuais
    // this.usuarioService.getEstoquesProdutos().then(snap => {
    //   snap.forEach(async element => {
    //     console.log(element);

    //     await this.usuarioService.updateProduto({ QuantidadeEstoque: element.QuantidadeEstoque }, element.ID);
    //   });
    // });
    //#endregion

    //#endregion Atualização 01/04/2023 BOLETOS V1
    //Usado dia 01/04/2023 para setar CompraPagamentoPendente false nos clientes.
    // this.usuarioService.getClientes().pipe(take(1)).subscribe(snap => {

    //   if (snap.length > 0) {
    //     snap.forEach((item, index) => {
    //       this.usuarioService.setCompraPagamentoPendenteTrue(item.key);
    //     });
    //   }
    // });
    //#endregion

    //#region Correção de crédito dos clientes
    // this.usuarioService.getClientes().pipe(take(1)).subscribe(async snap => {
    //   let clientes: ClienteFisicoElement[] = [];
    //   let auxCliente: ClienteFisicoElement;

    //   snap.forEach((item, index) => {
    //     auxCliente = item.payload.val() as ClienteFisicoElement;
    //     auxCliente.ID = item.key;
    //     clientes.push(auxCliente);
    //   });


    //   await Promise.all(clientes.map(async (cliente: ClienteFisicoElement) => {

    //     return await new Promise((resolve) => {
    //       console.log(cliente.CreditoDisponivel)
    //       if (cliente.CreditoDisponivel == undefined)
    //         return resolve(true);


    //       return this.usuarioService.getPedidosCliente(cliente.ID).pipe(take(1)).subscribe(async snap => {
    //         let pedido: PedidoConsultaElement;
    //         let creditoAbertoCliente = 0;

    //         snap.forEach((item, index) => {
    //           pedido = item.payload.val() as PedidoConsultaElement;

    //           if (pedido.StatusPagamento === 'Pendente') {
    //             console.log(pedido.Total)
    //             creditoAbertoCliente += Number(pedido.Total);
    //           }

    //         });

    //         console.log('cliente.ID: ' + cliente.ID);
    //         console.log('creditoAbertoCliente: ' + creditoAbertoCliente);
    //         console.log('Credito: ' + cliente.Credito);
    //         console.log('CreditoDisponivel: ' + cliente.CreditoDisponivel);

    //         return await this.usuarioService.updateCreditoCliente(cliente.ID, cliente.Credito - creditoAbertoCliente).then(resp => {
    //           return resolve(true);
    //         });
    //       });
    //     });
    //   }));

    // });
    //#endregion

    //#region Migrar vendedores de cliente
    // this.usuarioService.getClientes().pipe(take(1)).subscribe(async snap => {
    //   let clientes: ClienteFisicoElement[] = [];
    //   let auxCliente: ClienteFisicoElement;

    //   snap.forEach((item, index) => {
    //     auxCliente = item.payload.val() as ClienteFisicoElement;
    //     if (auxCliente.IDVendedor === 'ktW8XauFvWVvCvup66m3cSYnRr83') {
    //       auxCliente.ID = item.key;
    //       clientes.push(auxCliente);
    //     }
    //   });

    //   console.log('clientes', clientes)


    //   await Promise.all(clientes.map(async (cliente: ClienteFisicoElement) => {
    //     console.log('atualizado')

    //     return await new Promise(async (resolve) => {

    //       await this.usuarioService.updateCliente({IDVendedor: '3ii9PMeZ2iT2PxAqNBtX570qHtp2'}, '', cliente.ID);
    //       return resolve(true);
    //     });
    //   }));

    // });
    //#endregion



    //#region Alterar CompraViaBoleto clientes
    // this.usuarioService.getClientes().pipe(take(1)).subscribe(async snap => {
    //   let clienteIds: string[] = [];
    //   let auxCliente: ClienteFisicoElement;

    //   snap.forEach((item, index) => {
    //     auxCliente = item.payload.val() as ClienteFisicoElement;
    //     clienteIds.push(item.key);
    //   });

    //   console.log('clienteIds', clienteIds)


    //   await Promise.all(clienteIds.map(async (clienteId: string) => {
    //     console.log('atualizado')

    //     return await new Promise(async (resolve) => {
    //       console.log('atualizando cliente ID:', clienteId);

    //       await this.usuarioService.updateCliente({ CompraViaBoleto: false }, '', clienteId);
    //       return resolve(true);
    //     });
    //   }));

    // });
    //#endregion

    //#region colocar pedidos como dinheiro e pago
    // const pedidos = [
    //   25727,
    //   26060,
    //   26586,
    //   26703,
    //   27265,
    //   27756,
    //   28127,
    //   28740,
    //   29305,
    //   29359,
    //   29512,
    //   29516,
    //   29903,
    //   30017,
    //   30046,
    //   30282,
    //   30500,
    //   30519,
    //   30531,
    //   30745,
    //   30779,
    //   31005,
    //   31237,
    //   31270,
    //   31297,
    //   31305,
    //   31312,
    //   31388,
    //   31572,
    //   31688,
    //   31865,
    //   31893,
    //   32005,
    //   32082,
    //   32142,
    //   32209,
    //   32229,
    //   32252,
    //   32284,
    //   32303,
    //   32343,
    //   32346,
    //   32429,
    //   32457,
    //   32461,
    //   32522,
    //   32593,
    //   32611,
    //   32637,
    //   32675,
    //   32681,
    //   32691,
    //   32705,
    //   32737,
    //   32760,
    //   32768,
    //   32785,
    //   32791,
    //   32801,
    //   32806
    // ]

    // pedidos.forEach(async pedido => {
    //   await this.usuarioService.updatePedidoDinheiroPago(pedido);

    //   this.usuarioService.getPedidoPorNumero(pedido).pipe(take(1)).subscribe(async snap => {
    //     if (snap.payload.exists()) {
    //       const dados = snap.payload.val() as PedidoConsultaElement;

    //       if (dados.IDBoleto && dados.IDBoleto.length > 0) {
    //         await this.usuarioService.updateStatusBoleto(dados.IDBoleto, {
    //           SituacaoBoleto: 'Baixado',
    //           Status: 'Cancelado'
    //         });
    //       }

    //       if (dados.IDBoleto2 && dados.IDBoleto2.length > 0) {
    //         await this.usuarioService.updateStatusBoleto(dados.IDBoleto2, {
    //           SituacaoBoleto: 'Baixado',
    //           Status: 'Cancelado'
    //         });
    //       }
    //     }
    //   });
    // });
    //#endregion

    //#region atualizar custo dos produtos
    // const produtos: any = [
    //   {
    //     Key: "-NkvE6AWffN-KUz1muRJ", Custo: 0.00
    //   },
    // ];

    // produtos.forEach(async produto => {
    //   await this.usuarioService.updateProduto({ CustoCompra: produto.Custo }, produto.Key);
    // });
    //#endregion

  }
}
